<template>
  <v-container fluid>
    <div class="px-6 py-10" v-for="(metering, index) in page_content.metering" :key="`metering_${index}`">
      <v-row>
        <v-col
          v-for="(heading, i) in metering.headings"
          :key="`heading_${index}_${i}`"
          :cols="12 / metering.headings.length"
          :class="i == 0 ? 'border-right text-subtitle-2' : 'border-right text-subtitle-2 primaryOutline--text'"
        >
          {{ heading }}
        </v-col>
      </v-row>
      <v-row v-for="(value, i) in metering.values" :key="`data_${index}_${i}`">
        <v-col
          v-for="(elem, idx) in value"
          :key="`data_col_${i}_${idx}`"
          :cols="12 / metering.headings.length"
          :class="
            idx == 0
              ? 'text-subtitle-2 text-end border-right primaryGrey--text'
              : idx != value.length - 1
              ? 'border-right'
              : ''
          "
        >
          {{ idx == 0 ? elem : $numberFormat(metering_data ? metering_data[elem] : 0) }}
          <span class="mx-1">{{ idx == 0 && metering.units ? "" : metering.units[i] }}</span>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { axios_get } from "../services/vt_service";
import { scv } from "../services/powerdata";
import { content } from "../../config/scavenger.js";
import { scavenger_grpc_services } from "../services/ScavengerServices";

export default {
  name: "ScavengerAssetMetering",
  props: {
    device_id: String,
  },
  data: function () {
    return {
      page_content: null,
      acc_data: null,
      mtr_data: null,
    };
  },
  created() {
    this.page_content = content;
  },
  mounted() {
    this.get_acc_data();
    this.get_enrgy_mtr_data();
  },
  methods: {
    async get_acc_data() {
      this.dialog = false;
      this.overlay_type = "";
      this.network_error = false;
      // const response = await axios_get(scv.get_acc_data, { id: this.device_id });
      const response = await scavenger_grpc_services.GetAccumulatedPowerData(this.device_id);
      this.acc_data = response[0];
    },
    async get_enrgy_mtr_data() {
      this.dialog = false;
      this.overlay_type = "";
      this.network_error = false;
      // const response = await axios_get(scv.get_enrgy_mtr_data, { id: this.device_id });
      const response = await scavenger_grpc_services.GetEnrgyMtrData(this.device_id);
      this.mtr_data = response[0];
    },
  },
  computed: {
    metering_data: function () {
      return this.acc_data && this.mtr_data ? { ...this.acc_data, ...this.mtr_data } : null;
    },
  },
};
</script>
